import { Api } from "api";

export const getMiniApps = async (search: URLSearchParams, page?: number) => {
  let url = "/mini_apps/v1/admin";
  let params = search ? `?${search}` : "";
  const res = await Api.get(`${url}${params}`, {
    params: { page },
  });
  return res.data;
};

export const getMiniApp = async (id: string) => {
  const res = await Api.get(`/mini_apps/v1/admin/${id}/owner`);
  return res.data;
};

export const createMiniApp = async (payload: any) => {
  const res = await Api.post(`/mini_apps/v1/admin/`, payload);
  return res.data;
};

export const putMiniApp = async (id: string, payload: any) => {
  const res = await Api.put(`/mini_apps/v1/admin/${id}`, payload);
  return res.data;
};

export const deleteMiniApp = async (id: string) => {
  const res = await Api.delete(`/mini_apps/v1/admin/${id}`);
  return res.data;
};

export const getUpdates = async () => {
  const res = await Api.get(`/mini_apps/v1/admin/updates`);
  return res.data;
};

export const reviewRequest = async (id: string, payload: any) => {
  const res = await Api.put(`/mini_apps/v1/admin/${id}/request`, payload);
  return res.data;
};

export const reviewUpdate = async (id: string, payload: any) => {
  const res = await Api.put(`/mini_apps/v1/admin/update/${id}/review`, payload);
  return res.data;
};

export const closeUpdate = async (id: string) => {
  const res = await Api.put(`/mini_apps/v1/admin/update/${id}/close`, {});
  return res.data;
};

export const prepareLogoUpload: any = async (payload: any) => {
  const res = await Api.post("/files/v1/upload", payload);
  return res.data;
};

export const uploadLogo: any = async (query = "", payload: any) => {
  const res = await Api.put("/files/v1/upload" + query, payload);
  return res.data;
};

export const updateMiniAppAnonymous = async (id: string, is_anonymous: boolean) => {
  const res = await Api.put(`/mini_apps/v1/admin/${id}/anonymous`, { is_anonymous });
  return res.data;
};
